var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'pill',
    _vm.info && 'pill--info',
    _vm.infoWhite && 'pill--info-white',
    _vm.succes && 'pill--succes',
    _vm.danger && 'pill--danger',
    _vm.warn && 'pill--warn',
    _vm.cart && 'pill--cart',
    _vm.nav && 'pill--nav',
    _vm.navSelected && 'pill--nav-selected' ],on:{"click":function($event){return _vm.$emit('pill-click')}}},[_c('div',{staticClass:"pill__content"},[(_vm.text)?_c('div',{staticClass:"pill__text"},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")]):_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }